<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/PMReport/PMMonthly'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <!-- <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">เดือน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMonthCode'"
                    :name="'reMonthCode'"
                    :select2-options="reMonthOptions"
                    v-model="reMonthCode"
                  ></select2>
                </div>
              </div> -->

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">เดือน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMonthCode'"
                    :name="'reMonthCode'"
                    :select2-options="reMonthOptions"
                    v-model="reMonthCode"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYear'"
                    :name="'reYear'"
                    :select2-options="reYearOptions"
                    v-model="reYear"
                    ref="reYear"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    v-model="reDepartments"
                    @selectChange="onDepartmentChange"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    v-model="reAgentCodes"
                    @selectChange="onReAgentCodesChange()"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ชื่อช่างตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reUserId'"
                    :name="'reUserId'"
                    :select2-options="reUserIdOptions"
                    v-model="reUserId"
                  ></select2>
                </div>
              </div>


              

            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    v-model="reAgentCodes"
                    @selectChange="onReAgentCodesChange()"
                  ></select2> -->

                  <select2 
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'" 
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                     @selectChange="onReSubAgentCodesChange()"
                    multiple
                  ></select2>

                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ชื่อช่างตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSubAgentUserId'"
                    :name="'reSubAgentUserId'"
                    :select2-options="reSubAgentUserIdOptions"
                    v-model="reSubAgentUserId"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <!-- <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportQIGroupByAgent"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div> -->
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap" id="MonthlyTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="10">ข้อมูล ณ วันที่ {{ reAaDateReq }}</th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">จำนวนร้านค้า</th>
                    <th class="all text-center">จำนวนครั้งที่ทำ PM ทั้งหมด</th>
                    <th class="all text-center">รวม Alert เกินกำหนด</th>
                    <th class="all text-center">รวม Alert ก่อนครบกำหนด</th>
                    <th class="all text-center">ชื่อช่าง</th>
                    <th class="all text-center">จำนวนครั้งที่ทำ PM รายช่าง</th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reMonthCode: null,
      reAgentCodes: null,
      reUserId: null,
      reIsInitial: true,
      reDepartments: null,
      reYear: null,

      pmrSubAgentCodes : null,
      pmrSubAgentCodeOptions : [],

      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes : self.reAgentCodes != null ? [self.reAgentCodes] : null, 
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      reAgentCodesOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartments,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reDepartmentsOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reUserIdOptions: {
        placeholder: "กรุณาเลือกชื่อช่าง",
        allowClear: false,
        ajax: {
          type: "post",
          dataType: "json",
          contentType: "application/json",
          url: "/Api/Users/Select2UserGroupAgent2",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCode: self.reAgentCodes,
              agentTypeCode : "AGENT"
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reSubAgentUserIdOptions: {
        placeholder: "กรุณาเลือกชื่อช่าง",
        allowClear: false,
        ajax: {
          type: "post",
          dataType: "json",
          contentType: "application/json",
          url: "/Api/Users/Select2UserGroupAgent2",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCode: self.reAgentCodes,
              subAgentCodes : self.reAgentCodes,
              agentTypeCode : "SUB_AGENT"
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      reMonthOptions: {
        placeholder: "กรุณาเลือกเดือน",
        allowClear: true,
        data: [
          { id: "01", text: "January", data: null },
          { id: "02", text: "February", data: null },
          { id: "03", text: "March", data: null },
          { id: "04", text: "April", data: null },
          { id: "05", text: "May", data: null },
          { id: "06", text: "June", data: null },
          { id: "07", text: "July", data: null },
          { id: "08", text: "August", data: null },
          { id: "09", text: "September", data: null },
          { id: "10", text: "October", data: null },
          { id: "11", text: "November", data: null },
          { id: "12", text: "December", data: null },
        ],
      },
      reYearOptions: {
        placeholder: "กรุณาเลือกปี",
        data: [
          // { id: new Date().getFullYear()+543, text: new Date().getFullYear()+543, data: null },
          // { id: new Date().getFullYear()+542, text: new Date().getFullYear()+542, data: null },
          // { id: new Date().getFullYear()+541, text: new Date().getFullYear()+541, data: null },
          // { id: new Date().getFullYear()+540, text: new Date().getFullYear()+540, data: null },
          // { id: new Date().getFullYear()+539, text: new Date().getFullYear()+539, data: null }
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
          {
            id: new Date().getFullYear() - 2,
            text: new Date().getFullYear() - 2,
            data: null,
          },
          {
            id: new Date().getFullYear() - 3,
            text: new Date().getFullYear() - 3,
            data: null,
          },
          {
            id: new Date().getFullYear() - 4,
            text: new Date().getFullYear() - 4,
            data: null,
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reMonthCode = null;
      // self.reYear = null;
      self.reAgentCodes = null;
      self.reUserId = null;
      self.reDepartments = null; 
      self.pmrSubAgentCodes = null;

      $("#reMonthCode")
        .val("")
        .trigger("change");

      // $("#reYear")
      //   .val("")
      //   .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

        $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

      $("#reUserId")
        .val("")
        .trigger("change");

      $("#reDepartments")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (self.reMonthCode == null || self.reMonthCode == "" || self.reYear == null || self.reYear == "") {
        return false;
      }

      e.preventDefault();
      var table = $("#MonthlyTable").DataTable();
      table.draw();
    },
    onDepartmentChange() {
      this.reAgentCodes = null;

      $("#reAgentCodes")
        .val("")
        .trigger("change");

        this.pmrSubAgentCodes = null;

      $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

        
    },
    onReAgentCodesChange() {
      this.reUserId = null;

      $("#reUserId")
        .val("")
        .trigger("change");
    },
    onReSubAgentCodesChange() {
      this.reSubAgentUserId = null;

      $("#reSubAgentUserId")
        .val("")
        .trigger("change");
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
    
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#MonthlyTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/PMMonthly",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.reIsInitial,
              SalesArea: self.reDepartments,
              Agentcode: self.reAgentCodes,
              SubAgentCodes : self.pmrSubAgentCodes,
              UserId: self.reUserId,
              // DateCycle: self.reMonthCode,
              DateCycle: self.reYear + "-" + self.reMonthCode,
              // Month: self.reMonthCode,
              // Year: self.reYear,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[6, "desc"]],
        columns: [
          {
            data: "department",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "salesAreaName", className: "text-center" },
          { data: "agenT_NAME", className: "text-center" },
          {
            data: "totalShop",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === null) {
                return "-";
              } else {
                return data;
              }
            },
          },
          {
            data: "totalPMAgent",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === null) {
                return "-";
              } else {
                return data;
              }
            },
          },
          {
            data: "alertNext",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === 0) {
                return "-";
              } else {
                return data;
              }
            },
          },
          {
            data: "alertBefore",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === 0) {
                return "-";
              } else {
                return data;
              }
            },
          },
          {
            data: "userName",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === null) {
                return "-";
              } else {
                return data;
              }
            },
          },
          {
            data: "totalPM",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === null) {
                return "-";
              } else {
                return data;
              }
            },
          },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        reMonthCode: "required",
        reYear: "required",
      },
      messages: {
        reMonthCode: "กรุณาเลือกเดือน",
        reYear: "กรุณาเลือกปี",
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/PMMonthly.vue